var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DPDPill',{staticClass:"pill",attrs:{"label":_vm.label,"type":_vm.item.type},on:_vm._d({},[_vm.clickEvent,function($event){return _vm.$emit('click', $event)}])})
}
var staticRenderFns = []

export { render, staticRenderFns }